import React, { useEffect, useRef, useState } from "react";
import { Button, DatePicker, Modal, Radio, Select, Space, Table } from "antd";
import moment from "moment";
import Styles from "./Styles";
import ServiceInfo from "../../components/moleculas/ServiceInfo";
import SearchArea from "../../components/moleculas/SearchArea";
import { apiGet, apiGetPath, apiGetServiceCode, apiGetSitesComp, apiGetDeviceEvents } from "../../api/api";
import { getGlobalSessionParam, isEmpty, setGlobalSessionParam } from "../../utils/comm";

const { Column, ColumnGroup } = Table;
const options = [
  { type: "BEFORE_DAY", label: "1일", value: "days" },
  { type: "BEFORE_WEEK", label: "1주일", value: "weeks" },
  { type: "BEFORE_MONTH", label: "1개월", value: "months" },
  { type: "BEFORE_YEAR", label: "1년", value: "years" },
];

function Statics() {
  const StatusOptions = {
    SITE: "SITE",
    SERVICE: "SERVICE",
    SEARCH: "SEARCH",
  };
  const initStatus = useRef(
    new Map([
      [StatusOptions.SITE, false],
      [StatusOptions.SERVICE, false],
      [StatusOptions.SEARCH, false],
    ])
  );
  const [period, setPeriod] = useState("days");
  const [devList, setDevList] = useState([]);
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [apiGetSite, setApiGetSite] = useState([]);
  const [apiServiceCode, setGetServiceCode] = useState([]);
  const [siteId, setSiteId] = useState(null);
  const [svcCd, setSvcCd] = useState(null);
  const [evtList, setEvtList] = useState([]);
  const [zoneNm, setZoneNm] = useState(null);
  const [deviceEvtList, setDeviceEvtList] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [tmpList, setTmpList] = useState([]);

  // 사업장, 서비스 선택시 타이틀
  const [corpNm, setCorpNm] = useState(null);
  const [corpSev, setCorpSev] = useState(null);
  const [title, setTitle] = useState({
    corpNm: "",
    corpSevNm: "",
  });

  // [SVC-0104014040] 서비스별 이벤트 코드 조회
  const getEventCdList = async (svcCd) => {
    if (svcCd) {
      try {
        let catCdList = svcCd ? svcCd.toString() : null;

        const response = await apiGet(`Service/event`, {
          params: {
            catCdList: catCdList,
          },
        });

        if (response.data.code === 0) {
          const data = response.data.data.filter((item) => item.evtCd != null);
          setEvtList(data);
        } else {
          setEvtList([]);
        }
      } catch (e) {
        setEvtList([]);
      }
    } else {
      setEvtList([]);
    }
  };

  // Parameter Save
  const [defaultValue] = useState({
    siteId: !isEmpty(getGlobalSessionParam("siteId")) ? getGlobalSessionParam("siteId") : null,
    svcCd: !isEmpty(getGlobalSessionParam("svcCd")) ? getGlobalSessionParam("svcCd") : null,
    startDt: moment().format("YYYY-MM-DD"),
    endDt: moment().format("YYYY-MM-DD"),
    period: "days",
    corpNm: null,
    corpSev: null,
  });

  useEffect(() => {
    if (period) {
      setStartDate(moment().subtract(1, period).add(1, "days").format("YYYY-MM-DD"));
      setEndDate(moment().format("YYYY-MM-DD"));
    }
  }, [period]);

  const onChangeSiteComp = (value, option) => {
    setSiteId(option ? value : null);
    setSvcCd(null);
    setCorpNm(option ? option.label : null);
    apiGetServiceCodeCall(option ? value : null).then();
  };

  const onChangeServiceCode = (value, option) => {
    // getEventCdList(value).then();
    setSvcCd(option ? value : null);
    setCorpSev(option ? option.label : null);
  };

  // [SVC-0102014002] 사이트별 서비스 조회
  const apiGetSitesCompCall = async () => {
    const model = {
      compId: sessionStorage.getItem("compId"),
      userId: sessionStorage.getItem("userId"),
    };
    const response = await apiGetSitesComp(model);
    try {
      if (response.data.code === 0) {
        setApiGetSite(response.data.data);
      } else {
        setApiGetSite([]);
      }
    } catch (e) {
      setApiGetSite([]);
    }
  };

  // [SVC-0104014020] 사이트별 서비스 조회
  const apiGetServiceCodeCall = async (v) => {
    const model = {
      siteId: v,
      userId: sessionStorage.getItem("userId"),
    };
    const response = await apiGetServiceCode(model);
    try {
      // setSvcCd("");
      if (response.data.code === 0) {
        setGetServiceCode(response.data.data);
        // if (!isEmpty(svcCd)) {
        //     setSvcCd(svcCd);
        //     await searchApi();
        // }
      } else {
        setGetServiceCode([]);
      }
    } catch (e) {
      setGetServiceCode([]);
    }
  };

  // [SVC-0106014006] device별 통계 이벤트 목록 조회
  const apiGetDeviceEventsCall = async (data) => {
    const model = {
      siteId: siteId,
      svcCd: svcCd,
      znId: data.znId,
      startDt: startDate,
      endDt: endDate,
    };
    const response = await apiGetDeviceEvents(model);
    try {
      if (response.data.code === 0) {
        settingZoneEvts(response.data.data);
        setIsModalVisible(true);
      } else {
        setDeviceEvtList([]);
      }
    } catch (e) {
      setDeviceEvtList([]);
    }
  };

  function settingZoneEvts(data) {
    let head = new Set();
    let newSet = new Set();
    let newList = [];

    data.forEach((item) => newSet.add(item.devId));
    newList = Array.from(newSet).map((item, index) => {
      const evtFilterList = data.filter((evtItem) => evtItem.devId === item);
      const obj = { key: index };
      obj.devId = item;
      evtFilterList.forEach((evtItem) => {
        obj.devNm = evtItem.devNm;
        obj[evtItem.evtTp] = evtItem.count;
      });
      return obj;
    });

    data.forEach((item) => head.add(item.evtTp));

    const totalSum = { key: "totalSum" };
    totalSum["devNm"] = "전체";
    head.forEach((value) => {
      totalSum[value] = newList
        .map((item) => item[value])
        .reduce((pre, cur) => {
          if (!cur) {
            return pre;
          } else {
            return pre + cur;
          }
        }, 0);
    });
    setDeviceEvtList([totalSum, ...newList]);
  };

  function selectZone(data) {
    if(data.key != 'totalSum'){
      setZoneNm(data.znNm);
      apiGetDeviceEventsCall(data);
    }
  }

  const handlePeriod = (startDt, endDt) => {
    if (startDt && endDt && moment(endDt).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) {
      if (moment(startDt).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) {
        setPeriod("days");
      } else if (
        moment(startDt).format("YYYY-MM-DD") === moment().subtract(1, "weeks").add(1, "days").format("YYYY-MM-DD")
      ) {
        setPeriod("weeks");
      } else if (
        moment(startDt).format("YYYY-MM-DD") === moment().subtract(1, "months").add(1, "days").format("YYYY-MM-DD")
      ) {
        setPeriod("months");
      } else if (
        moment(startDt).format("YYYY-MM-DD") === moment().subtract(1, "years").add(1, "days").format("YYYY-MM-DD")
      ) {
        setPeriod("years");
      } else {
        setPeriod(null);
      }
    } else {
      setPeriod(null);
    }
  };

  useEffect(() => {
    apiGetSitesCompCall().then();
    if (defaultValue.svcCd) {
      apiGetServiceCodeCall(defaultValue.siteId).then();
    }
    getEventCdList(defaultValue.svcCd).then();
  }, []);

  useEffect(() => {
    if (apiGetSite != null && apiGetSite.length > 0 && !initStatus.current.get(StatusOptions.SITE)) {
      initStatus.current = new Map(initStatus.current).set(StatusOptions.SITE, true);

      const defaultSiteId = defaultValue.siteId;
      let includeFlag = false;
      if (!isEmpty(defaultSiteId)) {
        apiGetSite.forEach((item) => {
          if (item.siteId === defaultSiteId) {
            includeFlag = true;
          }
        });
      }
      if (includeFlag) {
        setSiteId(defaultSiteId);
      }
    }
  }, [apiGetSite]);

  useEffect(() => {
    if (apiServiceCode != null && apiServiceCode.length > 0 && !initStatus.current.get(StatusOptions.SERVICE)) {
      initStatus.current = new Map(initStatus.current).set(StatusOptions.SERVICE, true);
      setSvcCd(defaultValue.svcCd);
    }
  }, [apiServiceCode]);

  useEffect(() => {
    if (
      !initStatus.current.get(StatusOptions.SEARCH) &&
      !isEmpty(siteId) &&
      apiGetSite != null &&
      apiGetSite.length > 0 &&
      !isEmpty(svcCd) &&
      apiServiceCode != null &&
      apiServiceCode.length > 0
    ) {
      initStatus.current = new Map(initStatus.current).set(StatusOptions.SEARCH, true);
      searchApi().then();
    }
  }, [siteId, svcCd]);

  const onChangeRadio = (e) => {
    setPeriod(e.target.value);
  };

  const disabledDate = (current) => {
    return current > moment().endOf("day") || current < moment().subtract(10, "years");
  };

  const returnCount = (value, recode, index) => {
    return <div key={index}>{!value ? "0" : value} 건</div>;
  };
  const deviceCount = (value, recode, index) => {
    return <div key={index}>{!value ? "0" : value} 대</div>;
  };
  const zoneCount = (value, recode, index) => {
    return <div key={index}>{!value ? "0" : value} 건</div>;
  }

  /* 첫번째 콜 머지 */
  const getRowSpans = (arr, key) => {
    let sameValueLength = 0;
    const rowSpans = [];
    for (let i = arr.length - 1; i >= 0; i--) {
      if (i === 0) {
        rowSpans[i] = sameValueLength + 1;
        continue;
      }
      if (arr[i][key] === arr[i - 1][key]) {
        rowSpans[i] = 0;
        sameValueLength++;
      } else {
        rowSpans[i] = sameValueLength + 1;
        sameValueLength = 0;
      }
    }
    return rowSpans;
  };
  const rowSpans = getRowSpans(dataList, "znNm");

  const handleReset = () => {
    setStartDate(moment().format("YYYY-MM-DD"));
    setEndDate(moment().format("YYYY-MM-DD"));
    setSiteId(null);
    setSvcCd(null);
    setDevList([]);
    setCorpNm("");
    setCorpSev("");

    setEvtList([]);
    setTmpList([]);
    setDataList([]);

    setTitle({
      corpNm: "",
      corpSevNm: "",
    });
    setPeriod("days");

    setGlobalSessionParam({
      siteId: null,
      svcCd: null,
    });

    // handleApiGetSearch();
  };

  const handleApiGetSearch = () => {
    if (siteId && svcCd && startDate && endDate) {
      getEventCdList(svcCd).then((r) => r);
      searchApi().then((r) => r);
    }
  };

  // [SVC-0106014001] 홈 이벤트 목록 조회
  // [SVC-0105014005] 홈 디바이스 목록 조회
  const searchApi = async () => {
    const response = await apiGet(`Event/count/${siteId}/${svcCd}?startDt=${startDate}&endDt=${endDate}`);
    const response2 = await apiGetPath(`Device/count/${siteId}/${svcCd}`);

    setGlobalSessionParam({
      siteId: siteId,
      svcCd: svcCd,
    });

    try {
      if (response.data.code === 0) {
        setDataList(response.data.data);
      } else if (response.data.code === 10) {
        setDataList([]);
      }

      if (response2.code === 0) {
        setDevList(response2.data);
      } else if (response2.code === 10) {
        setDevList([]);
      }
      setTitle({
        corpNm: corpNm,
        corpSevNm: corpSev,
      });
    } catch (error) {}
  };

  useEffect(() => {
    let head = new Set();
    let newSet = new Set();
    let newList = [];

    dataList.forEach((item) => newSet.add(item.znId));

    newList = Array.from(newSet).map((item, index) => {
      const evtFilterList = dataList.filter((evtItem) => evtItem.znId === item);
      const devFilterList = devList.filter((devItem) => devItem.znId === item);
      const obj = { key: index };
      obj.znId = item;
      evtFilterList.forEach((evtItem) => {
        obj.znNm = evtItem.znNm;
        obj[evtItem.evtTp] = evtItem.count;
      });
      devFilterList.forEach((devItem) => {
        obj.znNm = devItem.znNm;
        obj.devCount = devItem.devCount;
      });
      return obj;
    });

    dataList.forEach((item) => head.add(item.evtTp));

    const totalSum = { key: "totalSum" };
    totalSum["znNm"] = "전체";
    head.forEach((value) => {
      totalSum[value] = newList
        .map((item) => item[value])
        .reduce((pre, cur) => {
          if (!cur) {
            return pre;
          } else {
            return pre + cur;
          }
        }, 0);
    });
    totalSum["devCount"] = newList
      .map((item) => item.devCount)
      .reduce((pre, cur) => {
        if (!cur) {
          return pre;
        } else {
          return pre + cur;
        }
      }, 0);

    setTmpList([totalSum, ...newList]);
  }, [dataList, devList]);

  return (
    <Styles className='has-table-resize'>
      <h1 className='page-tit'>홈</h1>
      <SearchArea
        leftExtra={
          <Space size={[12, "small"]}>
            <div className='condition-item'>
              <label htmlFor='s1'>사업장</label>
              <Select
                style={{ width: 148 }}
                id='s1'
                placeholder='선택'
                // defaultValue={{value:"-1", label:"선택"}}
                value={siteId}
                onChange={(value, option) => onChangeSiteComp(value, option)}
                options={apiGetSite.map((item, index) => ({
                  key: index,
                  value: item.siteId,
                  label: item.siteNm,
                }))}
              ></Select>
            </div>
            <div className='condition-item'>
              <label htmlFor='s2'>서비스</label>
              <Select
                style={{ width: 230 }}
                // defaultValue={defaultValue.svcCd}
                value={svcCd}
                id='s2'
                placeholder='선택'
                onChange={(value, option) => onChangeServiceCode(value, option)}
                options={apiServiceCode.map((item, index) => ({
                  key: index,
                  value: item.catCd,
                  label: item.catNm,
                }))}
              ></Select>
            </div>
          </Space>
        }
      />
      <SearchArea
        leftExtra={
          <Space>
            <Radio.Group
              options={options}
              onChange={onChangeRadio}
              value={period}
              optionType='button'
              buttonStyle='solid'
            />
            <Space>
              <DatePicker
                format={["YYYY-MM-DD", "YYYYMMDD", "YYYY.MM.DD"]}
                value={moment(startDate)}
                onChange={(date) => {
                  setStartDate(date.format("YYYY-MM-DD"));
                  handlePeriod(date, endDate);
                }}
                disabledDate={disabledDate}
                allowClear={false}
              />{" "}
              ~
              <DatePicker
                format={["YYYY-MM-DD", "YYYYMMDD", "YYYY.MM.DD"]}
                value={moment(endDate)}
                onChange={(date) => {
                  setEndDate(date.format("YYYY-MM-DD"));
                  handlePeriod(startDate, date);
                }}
                disabledDate={disabledDate}
                allowClear={false}
              />
            </Space>
          </Space>
        }
        rightExtra={
          <Space>
            <Button type='primary' className='btn-wide' onClick={handleApiGetSearch}>
              조회
            </Button>
            <Button className='btn-gray' onClick={handleReset}>
              초기화
            </Button>
          </Space>
        }
      />
      <ServiceInfo children={title} />
      <div className='tbl-resize-wrapper' style={{ minHeight: 300 }}>
        <Table dataSource={tmpList} bordered pagination={false} showSorterTooltip={false} scroll={{ x: 1300 }}  
          onRow={(record, rowIndex) => {
            return {
              onClick: event => {selectZone(record)},
            };
          }}>
          <Column
            title={"구분"}
            colSpan={2}
            key='znNm'
            onCell={(record, index) => ({ rowSpan: rowSpans[index] })}
            render={() => ({ children: "구역" })}
          />
          <Column dataIndex={"znNm"} colSpan={0} render={(value) => value} />
          <ColumnGroup title={"위험이벤트 유형"}>
            {evtList.map((item, index) => (
              <Column title={item.evtNm} key={index} dataIndex={item.evtCd} render={returnCount} />
            ))}
          </ColumnGroup>
          <ColumnGroup title={"디바이스"}>
            {devList.map((item, index) => (
              <Column title={"AI머신비전"} key={index} dataIndex={"devCount"} render={deviceCount} />
            ))}
          </ColumnGroup>
        </Table>
      </div>
      <Modal
        title={zoneNm + ' 통계 조회'}
        visible={isModalVisible}
        onOk={() => setIsModalVisible(false)}
        onCancel={() => setIsModalVisible(false)}
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ style: { display: "none" } }}
        getContainer={false}
        width={"fit-content"}
        footer={null}
        bodyStyle={{ paddingBottom: "35px" }}
        // 스와이퍼가 있는 모달에서 마우스로 슬라이딩시 터치 미스로 딤처리 영역 클릭시 팝업이 닫혀버리는 현상 방지하기위해 지정 maskClosable
        maskClosable={false}
        className={"eventModal"}
      > 
        <Table dataSource={deviceEvtList} bordered pagination={false} showSorterTooltip={false} scroll={{ x: 1300 }} >
          <ColumnGroup title={"장비"}>
            <Column title={"장비 ID"} dataIndex={"devId"} render={(value) => value} />
            <Column title={"장비 이름"} dataIndex={"devNm"} render={(value) => value} />
          </ColumnGroup>
          <ColumnGroup title={"위험이벤트 유형"}>
            {evtList.map((item, index) => (
              <Column title={item.evtNm} key={index} dataIndex={item.evtCd} render={zoneCount} />
            ))}
          </ColumnGroup>
        </Table>
      </Modal>
    </Styles>
  );
}

export default Statics;
